const map = {
	"./battery_0.png": 5732,
	"./battery_100.png": 6125,
	"./battery_20.png": 9028,
	"./battery_40.png": 4418,
	"./battery_60.png": 9304,
	"./battery_80.png": 8614
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5149;